import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d2c9287"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tour-mask" }, null, -1))
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "tour-caption" }
const _hoisted_4 = {
  key: 0,
  class: "tour-hint"
}
const _hoisted_5 = { class: "tour-buttons" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.active)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "admin-step-tour",
          onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.finish && _ctx.finish(...args)), ["prevent"]), ["esc"]))
        }, [
          _hoisted_1,
          (_ctx.target)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "tour-spotlight",
                style: _normalizeStyle(_ctx.highlightStyle)
              }, null, 4))
            : _createCommentVNode("", true),
          _createElementVNode("section", {
            ref: "panel",
            class: "tour-card",
            role: "dialog",
            "aria-modal": "true",
            "aria-label": _ctx.step?.title || '分步引导',
            tabindex: "-1",
            style: _normalizeStyle(_ctx.cardStyle)
          }, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.label) + " · 第 " + _toDisplayString(_ctx.position + 1) + " / " + _toDisplayString(_ctx.steps.length) + " 步", 1),
            _createElementVNode("h2", null, _toDisplayString(_ctx.step?.title), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.step?.content), 1),
            (!_ctx.target)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, "当前页面未显示此区域（可能没有数据或权限），可继续下一步。"))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                disabled: _ctx.position === 0 || _ctx.busy,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.move(-1)))
              }, "上一步", 8, _hoisted_6),
              _createElementVNode("button", {
                disabled: _ctx.busy,
                class: "tour-next",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
              }, _toDisplayString(_ctx.position === _ctx.steps.length - 1 ? '完成' : '下一步'), 9, _hoisted_7),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.finish && _ctx.finish(...args)))
              }, "结束引导")
            ]),
            (_ctx.showCatalog)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "tour-skip",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('catalog')))
                }, "全部／分组教程"))
              : _createCommentVNode("", true),
            (_ctx.position < _ctx.steps.length-1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "tour-skip",
                  disabled: _ctx.busy,
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
                }, "跳过本步", 8, _hoisted_8))
              : _createCommentVNode("", true)
          ], 12, _hoisted_2)
        ], 32))
      : _createCommentVNode("", true)
  ]))
}